import { Outlet } from 'react-router-dom';

import OtaUpdateMonitor from '../components/shared/ota-update-monitor';
import {
  OnboardingProvider,
  PostAugmentationTourProvider,
  ProTipProvider,
} from '../modules/onboarding';
import { AllWorkspaceModals } from '../providers/modal-provider';

export const RootWrapper = () => {
  return (
    <OnboardingProvider>
      <ProTipProvider>
        <PostAugmentationTourProvider>
          <AllWorkspaceModals />
          {environment.isTauri && <OtaUpdateMonitor />}
          <Outlet />
        </PostAugmentationTourProvider>
      </ProTipProvider>
    </OnboardingProvider>
  );
};
